import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import SystemComponentCreateViewModel from "viewModels/administration/systemComponents/systemComponentCreateViewModel";
import CreateView from "../../common/create";
import SystemComponentForm from "./systemComponentForm";

const SystemComponentCreateView: ViewComponent<SystemComponentCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<SystemComponentForm vm={vm} />} />
));

registerView(SystemComponentCreateView, SystemComponentCreateViewModel);
